import { Controls } from "./components/Controls";
import { SourceCards } from "./components/SourceCards";
import { StatusPill } from "./components/StatusPill";
import { Transcript } from "./components/Transcript";
import { VideoStage } from "./components/VideoStage";
import { useConversation } from "./hooks/useConversation";

/**
 * Deliberately restrained. The avatar is the product; this is a frame around it.
 */
export default function App() {
  const conversation = useConversation();

  return (
    <div className="app">
      <header className="app__header">
        <div>
          <h1 className="app__title">Àdùnní</h1>
          <p className="app__subtitle">Realtime AI Human</p>
        </div>
        <StatusPill state={conversation.status} />
      </header>

      {conversation.error && (
        <div className="banner banner--error" role="alert">
          {conversation.error}
        </div>
      )}

      <main className="app__main">
        <div className="app__stage">
          <VideoStage
            callObject={conversation.callObject}
            connected={conversation.connected}
            status={conversation.status}
            camOn={conversation.camOn}
          />
          <Controls
            connected={conversation.connected}
            starting={conversation.starting}
            micOn={conversation.micOn}
            camOn={conversation.camOn}
            onStart={conversation.start}
            onStop={conversation.stop}
            onRestart={conversation.restart}
            onToggleMic={conversation.toggleMic}
            onToggleCam={conversation.toggleCam}
          />
          <p className="app__hint">
            Talk naturally — you can interrupt her at any point, and show her
            things through the camera.
          </p>
        </div>

        <aside className="app__side">
          <Transcript entries={conversation.transcript} />
          <SourceCards groups={conversation.sourceGroups} />
        </aside>
      </main>
    </div>
  );
}
